module.exports = __webpack_public_path__ + "img/multicards.29eef2eb.svg";